import { redirectTo } from 'containers/PrivateRoute/actions';
import routeConfig from 'utils/routeConfig';
import { LOGIN_SUCCESS, LOGOUT_SUCCESS } from 'containers/App/constants';
import { LOAD_CLAIM_SUCCESS, CREATE_NEW_CLAIM_SUCCESS } from 'containers/ClaimList/constants';
import createMiddleware from './middleware';

export const redirectMiddleware = createMiddleware([
  {
    // Redirect user to index page on successful TODO delete
    action: LOGIN_SUCCESS,
    afterHandler: (storeAPI) => {
      // Add a small delay to ensure state is fully updated and components have re-rendered
      // This prevents race conditions where ClaimList tries to load before token/policyId are available
      setTimeout(() => {
        const state = storeAPI.getState();
        const isAuthenticated = state.get('global').get('isAuthenticated');
        // Only redirect if authentication state is confirmed
        if (isAuthenticated) {
          redirectTo(routeConfig.claimList);
        }
      }, 100);
    },
  },
  {
    // Redirect user to index page on successful TODO delete
    action: LOAD_CLAIM_SUCCESS,
    afterHandler: () => {
      redirectTo(routeConfig.claimWizard);
    },
  },
  {
    // Redirect user to index page on successful TODO delete
    action: CREATE_NEW_CLAIM_SUCCESS,
    afterHandler: () => {
      redirectTo(routeConfig.claimWizard);
    },
  },
  {
    // Redirect user to index page on successful TODO delete
    action: LOGOUT_SUCCESS,
    afterHandler: () => {
      redirectTo(routeConfig.login);
    },
  },
]);



// WEBPACK FOOTER //
// ./app/utils/middleware/redirectMiddleware.js